import axios from 'axios'
import library from '../../../utils/Library'

export const helpGetUserLoginAccountWithEmail = async (email) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL = library.getBaseAPIUrl('login_account') + '/loginAccountByEmail'

  return await axios.get(URL, {
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    params: {
      email: email
    }
  })
}
